import React from 'react';
import styled from 'styled-components';

const Container = styled.li`
  padding: 0 30px;
  display: block;
  @media (max-width: 980px) {
    padding: 0 20px;
  }
  button {
    cursor: pointer;
    text-decoration: none;
    color: #848484;
    border: 0;
    background: none;
    font: 14px Montserrat;
    line-height: 30px;
    display: block;
    border-bottom: 6px solid transparent;
    &.active {
      color: #6A7C40;
      border-color: #6A7C40;
    }
  }
`;

const ContentTabsItem = ({text, active, toggleCategory}) => {
  return (
    <Container>
      <button onClick={ toggleCategory } name={ text } className={ active === text ? 'active' : '' }>{ text }</button>
    </Container>
  );
}

export default ContentTabsItem;
